var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.37,
    height: 11.37
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.49 4.81H6.56V.88a.88.88 0 10-1.75 0v3.93H.88a.88.88 0 100 1.75h3.93v3.93a.88.88 0 101.75 0V6.56h3.93a.88.88 0 100-1.75z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMS4zNyIgaGVpZ2h0PSIxMS4zNyIgdmlld0JveD0iMCAwIDExLjM3IDExLjM3Ij4KICA8cGF0aCBkPSJNMTAuNDksNC44MUg2LjU2Vi44OGEuODguODgsMCwxLDAtMS43NSwwVjQuODFILjg4YS44OC44OCwwLDEsMCwwLDEuNzVINC44MXYzLjkzYS44OC44OCwwLDEsMCwxLjc1LDBWNi41NmgzLjkzYS44OC44OCwwLDEsMCwwLTEuNzVaIi8+Cjwvc3ZnPgo=";
export { SvgPlus as ReactComponent };